import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
export default {
  type: 'catalog_order',
  aliases: ['demande'],
  slices: [{
    name: 'catalog_form',
    path: 'CatalogOrder/FormCatalog.vue'
  }]
};